import { Button, Flex, FormControl, FormLabel, Grid, HStack, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, Textarea } from "@chakra-ui/react"

interface Props {
    isOpen: boolean,
    onClose: any
}

const LifeMissing = ({ isOpen, onClose }: Props) => {
    return (
        <Modal onClose={onClose} isOpen={isOpen} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Vida não compareceu</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Flex direction="column" w="100%">
                        <Text size="sm" mb="12px">Confirme o não comparecimento</Text>
                        <Grid
                            w="full"
                            templateColumns={{ sm: "1fr", md: "repeat(1, 1fr)" }}
                            gap="24px"
                            mb="24px"
                        >
                            <FormControl>
                                <FormLabel
                                    fontWeight="bold"
                                    fontSize="xs"
                                >
                                    Detalhamento
                                </FormLabel>
                                <Textarea />
                            </FormControl>
                        </Grid>
                    </Flex>
                </ModalBody>
                <ModalFooter>
                    <HStack spacing={4}>
                        <Button variant="ghost" onClick={onClose}>Cancelar</Button>
                        <Button colorScheme="purple" onClick={onClose}>Confirmar</Button>
                    </HStack>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default LifeMissing
